import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-main">
          <Link className="wordmark footer-wordmark" to="/" aria-label="candradimuka.id cibubur, beranda">
            <span className="brand-mark" aria-hidden="true">C</span>
            <span>candradimuka.id cibubur</span>
          </Link>
          <p>Training, digital, dan pemberdayaan diri.</p>
          <nav className="footer-links" aria-label="Navigasi footer">
            <a href="https://hipnoterapi.ws" target="_blank" rel="noopener noreferrer">
              Klinik Hipnoterapi
            </a>
            <a href="https://zeromind.app" target="_blank" rel="noopener noreferrer">ZeroMind</a>
            <a href="https://lakukeras.id" target="_blank" rel="noopener noreferrer">LakuKeras.id</a>
            <a href="https://infosecguru.id" target="_blank" rel="noopener noreferrer">InfoSecGuru</a>
            <a href="mailto:info@candradimuka.id">Email</a>
            <Link to="/privacy-policy">Kebijakan Privasi</Link>
          </nav>
        </div>
        <div className="footer-bottom">
          <span>© 2026 candradimuka.id cibubur. Hak cipta dilindungi.</span>
          <a href="https://bit.ly/WACoachYuan" target="_blank" rel="noopener noreferrer">
            Hubungi kami melalui WhatsApp
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;